// @flow
import React, { Component } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';

import Card, { CardHeader, CardText } from 'material-ui/Card';
import List, { ListItem } from 'material-ui/List';

import ContactForm from './ContactForm';
import ContactSentMessagae from './ContactSentMessage';
import ContactMethodList from './ContactMethodList';

const getStyles = ({ isMobile }) => ({
  container: {
    display: isMobile ? 'block' : 'flex',
    padding: isMobile ? 0 : 8,
  },
});

export default class ContactCard extends Component {
  render() {
    const isMobile = this.props.browser.lessThan.medium;
    const styles = getStyles({ isMobile });
    return (
      <div style={styles.container}>
        <ContactForm {...this.props} />
        <ContactMethodList {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/ContactCard.js